module.exports = "<button (click)=\"dialogShow()\" class=\"btn btn-xs main-color\" aria-label=\"create account\">Create Account ...</button>\n"